"use client";

import { Badge } from "@/components/ui/Badge";
import type { MakeupStatus } from "@/openapi/generated";
import { useThemeTokens } from "@/lib/theme/tokens";
import {
  makeupStatusBadgeColors,
  makeupStatusLabel,
  type MakeupStatusLabelOptions,
} from "./makeupStatus";

type MakeupStatusBadgeProps = {
  status: MakeupStatus;
  fontSize?: string;
} & MakeupStatusLabelOptions;

export function MakeupStatusBadge({
  status,
  fontSize = "11px",
  changeRequestedLabel,
}: MakeupStatusBadgeProps) {
  const theme = useThemeTokens();
  const label = makeupStatusLabel(status, { changeRequestedLabel });
  const colors = makeupStatusBadgeColors(status);

  return (
    <Badge
      fontSize={fontSize}
      bg={theme.mode === "dark" ? colors.bgDark : colors.bgLight}
      color={colors.color}
      borderWidth="1px"
      borderColor={colors.borderColor}
    >
      {label}
    </Badge>
  );
}
